export default "__VITE_ASSET__BzNG$z9t__ 584w";